<template>
  <v-form
    ref="form"
    v-model="formValid"
    @submit.prevent="save()"
  >
    <page-template>
      <template
        v-if="!hideTopParams"
        slot="title"
      >
        <div
          class="d-flex align-center justify-start pa-8"
        >
          <page-title
            v-if="pageTitle"
            :title="pageTitle"
            :back-to="navigateBackRoute"
            :back-params="navigateBackParams"
          />
        </div>
      </template>
      <template slot="content">
        <v-row v-if="removeCard">
          <v-col cols="12">
            <v-container
              class="py-0"
              fluid
              grid-list-xl
            >
              <v-row
                v-for="slot in totalGroup"
                :key="slot"
              >
                <slot :name="getSlotGroupName(slot)" />
              </v-row>
            </v-container>

            <v-divider />

            <slot
              name="action"
              :to="() => navigateTo(navigateBackRoute, navigateBackParams)"
              :loading="loadingForm"
            />
            <div
              v-if="!removeButtons"
              class="pa-4 d-flex justify-end align-center"
            >
              <div v-if="!removeCancel">
                <v-btn
                  color="#6A6E7B"
                  outlined
                  @click="navigateTo(navigateBackRoute, navigateBackParams)"
                >
                  CANCELAR
                </v-btn>
              </div>
              <div
                v-if="!removeSalvar"
                class="ml-2"
              >
                <v-btn
                  class="white--text"
                  type="submit"
                  color="#2ABD49"
                  :loading="loadingForm"
                >
                  SALVAR
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-card v-else>
          <v-container
            class="py-0"
            fluid
            grid-list-xl
          >
            <v-row
              v-for="slot in totalGroup"
              :key="slot"
            >
              <slot :name="getSlotGroupName(slot)" />
            </v-row>
          </v-container>

          <v-divider />
          <slot
            name="action"
            :to="() => navigateTo(navigateBackRoute, navigateBackParams)"
            :loading="loadingForm"
          />
          <div
            v-if="!removeButtons"
            class="pa-4 d-flex justify-end align-center"
          >
            <div v-if="!removeCancel">
              <v-btn
                color="#6A6E7B"
                outlined
                @click="navigateTo(navigateBackRoute, navigateBackParams)"
              >
                CANCELAR
              </v-btn>
            </div>
            <div
              v-if="!removeSalvar"
              class="ml-2"
            >
              <v-btn
                class="white--text"
                type="submit"
                color="#2ABD49"
                :loading="loadingForm"
                :disabled="disabledUpdate"
              >
                SALVAR
              </v-btn>
            </div>
          </div>
        </v-card>
      </template>
    </page-template>
  </v-form>
</template>

<script>
import PageTitle from 'Arch/template/PageTitle.vue';
import PageTemplate from 'Arch/template/PageTemplate.vue';
import RouterMixin from 'Arch/mixins/RouterMixin';
import FormMixin from 'Arch/components/crud/crud-mixins/FormMixin';
import UtilsMixin from 'Arch/mixins/UtilsMixin';

export default {
  name: 'CrudForm',
  components: {
    PageTemplate,
    PageTitle,
  },
  mixins: [RouterMixin, FormMixin, UtilsMixin],
  props: {
    loadingCrudForm: {
      type: Boolean,
    },
    value: {
      type: [Object, Array],
      required: true,
    },
    totalGroup: {
      type: Number,
      required: true,
    },
    pageTitle: {
      type: String,
      default: '',
    },
    navigateBackRoute: {
      type: String,
      required: true,
    },
    navigateBackParams: {
      type: Object,
      default: () => {},
    },
    navigatePageAfterSave: {
      type: String,
      default: null,
    },
    requestClass: {
      type: [Function, Object],
      required: true,
    },
    requestOnCreate: {
      type: Boolean,
      default: true,
    },
    removeCancel: {
      type: Boolean,
      default: false,
    },
    removeSalvar: {
      type: Boolean,
      default: false,
    },
    removeButtons: {
      type: Boolean,
      default: false,
    },
    removeCard: {
      type: Boolean,
      default: false,
    },
    overrideEditPayload: {
      type: Function,
      default: null,
    },
    overrideCreatePayload: {
      type: Function,
      default: null,
    },
    overrideSetEntityData: {
      type: Function,
      default: null,
    },
    onSaveExtraClass: {
      type: Function,
      default: null,
    },
    onEditExtraClass: {
      type: Function,
      default: null,
    },
    calledInsideSave: {
      type: Function,
      default: null,
    },
    staticId: {
      type: [Number, String],
      default: null,
    },
    lockGetIdParams: {
      type: Boolean,
      default: false,
    },
    hideTopParams: {
      type: [Boolean, Number],
      default: false,
    },
    setDataLoading: {
      type: Boolean,
      default: false,
    },
    calledInsideEdit: {
      type: Function,
      default: null,
    },
    extraValidated: {
      type: Function,
      default: null,
    },
    disabledUpdate: {
      type: Boolean,
      default: false,
    },
  },
  data: (vm) => ({
    loadEntityOnCreate: vm.requestOnCreate,
  }),
  computed: {
    payload: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    navigateToPageAfterSave() {
      return this.navigatePageAfterSave;
    },
  },
  methods: {
    reloadEdit() {
      this.makeEditSetCall();
    },
    getSlotGroupName(slot) {
      return `group-${slot}`;
    },
    getEditPayload() {
      if (this.overrideEditPayload) {
        return this.overrideEditPayload(this.payload);
      }
      return this.payload;
    },
    setEntityData(data) {
      if (this.overrideSetEntityData) {
        this.payload = this.overrideSetEntityData(
          this.overrideNullProperties(
            data,
            this.payload,
          ),
        );
        return;
      }
      this.payload = this.setOverrideProps(
        data,
        this.payload,
      );
    },
    getCreatePayload() {
      if (this.overrideCreatePayload) {
        return this.overrideCreatePayload(this.payload);
      }
      return this.payload;
    },
    manualSendForm() {
      this.$root.$on('save-changes', (value) => {
        if (value) {
          this.save();
        }
      });
    },
  },
  reactiveProvide: {
    name: 'crudForm',
    include: ['validateForm', 'reloadEdit'],
  },
};
</script>
